<template>
  <div>
    <label class="flex items-center gap-x-2 text-sm font-medium leading-6 text-gray-900">
      {{ label }}
      <slot name="label-color" />
    </label>
    <div class="mt-1 relative">
      <vue3-tags-input
        :tags="model"
        :placeholder="placeholder"
        :read-only="readonly"
        @on-tags-changed="tags => model = tags"
      />
    </div>
  </div>
</template>

<script setup>
import Vue3TagsInput from 'vue3-tags-input';

defineProps({
  label: {
    type: String,
    default: null
  },
  placeholder: {
    type: String,
    default: null
  },
  errorMsg: {
    type: String,
    default: ''
  },
  readonly: {
    type: Boolean,
    default: false
  }
});

const model = defineModel({
  type: Array,
  default: () => []
});
</script>
